import React from 'react'
import { ChangePasswordView } from '../../views'


/**
 * @class ChangePasswordEmailAction
 * @extends {React.Component}
 * @status no delete
 * @description Change email password class that shows all functionalities required for changing email password
 */
class ChangePasswordEmailAction extends React.Component {
    constructor(props) {
        super(props)
        this.props = props
    }

    token = {}

    async componentDidMount() {
        this.token = this.props.token
    }

    render() {
        return (
            <ChangePasswordView
                token={this.token}
            />
        )
    }
}
export { ChangePasswordEmailAction as default }